<ax-icon class="icon success-icon" [ngClass]="color" [name]="name"></ax-icon>
